module.exports = __webpack_public_path__ + "static/img/courses00.fc21c37c.png";